import {LEGAL_ALIASES, LEGAL_KINDS, legalPath} from '../legal/legal-helpers'
import {LegalPage} from '../pages/legal/legal-page'

// Public legal pages: no login, no venue. /privacy, /terms, /data-deletion and the same under /th, plus the
// old addresses (the old Facebook apps used /policy and /terms-and-conditions) which show the same page.
export const legalRoutes = [
  ...LEGAL_KINDS.flatMap((kind) => [
    {path: legalPath(kind, 'en'), element: <LegalPage kind={kind} lang='en' />},
    {path: legalPath(kind, 'th'), element: <LegalPage kind={kind} lang='th' />},
  ]),
  ...LEGAL_ALIASES.map(({kind, path}) => ({path, element: <LegalPage kind={kind} lang='en' />})),
]
